export const presentOnAdmissionMap: { [key: string]: string } = {
    'Y': 'Y - Yes',
    'N': 'N - No',
    'U': 'U - Unknown',
    'W': 'W - Clinically undetermined',
    '1': '1 - Unreported/Not Used (Exempt from POA reporting)',
    //Map draft POA status with "I" to "1"
    'I': '1 - Unreported/Not Used (Exempt from POA reporting)'
}

export const presentOnAdmissionDisplayMap: { [key: string]: string } = {
    'Y - Yes': 'Y',
    'N - No': 'N',
    'U - Unknown': 'U',
    'W - Clinically undetermined': 'W',
    '1 - Unreported/Not Used (Exempt from POA reporting)': '1'
}

export const presentOnAdmissionsDisplayValues = [
    'Y - Yes',
    'N - No',
    'U - Unknown',
    'W - Clinically undetermined',
    '1 - Unreported/Not Used (Exempt from POA reporting)'
]
